import { render, staticRenderFns } from "./FraudTooltip.vue?vue&type=template&id=35438e7f&"
import script from "./FraudTooltip.vue?vue&type=script&lang=ts&"
export * from "./FraudTooltip.vue?vue&type=script&lang=ts&"
import style0 from "./FraudTooltip.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports